export default function ServicesTabsController(
  $scope,
  $location,
  $stateParams,
  merchantService,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.merchant = $stateParams.merchant;
  vm.isLoading = true;

  init();

  function init() {
    getMerchant();
  }

  function getMerchant() {
    return merchantService.getMerchantById(vm.merchantId).then(function(res) {
      if (res && res.data) {
        vm.merchant = res.data;
      }
    }).finally(function() {
      vm.isLoading = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/services/services-tabs/services-tabs.controller.js